export default {"src":"/_next/static/media/small_snowflake.3085c68a.svg","height":37,"width":32,"blurWidth":0,"blurHeight":0};